import gql from 'graphql-tag';

export default gql`
    query homepage {
        homepage {
            ... on Homepage {
                h1TitleTag
                brandHeadline
                heroImage {
                    altText
                    url
                    focalPoint
                }
            }
            ... on CMSError {
                errorCode
            }
        }
    }
`;
